import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useThemeStore } from '../store/themeStore';

const ExploreButton: React.FC = () => {
  const navigate = useNavigate();
  const theme = useThemeStore((s) => s.theme);
  const isDark = theme === 'dark';

  return (
    <motion.button
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.5, type: 'spring', damping: 20 }}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      onClick={() => navigate('/image-gen')}
      className="relative group flex items-center gap-2 px-3.5 py-1.5 rounded-full overflow-hidden cursor-pointer"
    >
      {/* Animated gradient background */}
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          background: 'linear-gradient(135deg, #8b5cf6, #6366f1, #a855f7, #7c3aed)',
          backgroundSize: '300% 300%',
        }}
        animate={{
          backgroundPosition: ['0% 50%', '100% 50%', '0% 50%'],
        }}
        transition={{ duration: 4, repeat: Infinity, ease: 'linear' }}
      />

      {/* Shimmer overlay */}
      <motion.div
        className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{
          background:
            'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)',
          backgroundSize: '200% 100%',
        }}
        animate={{
          backgroundPosition: ['-100% 0', '200% 0'],
        }}
        transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 0.5 }}
      />

      {/* Glow */}
      <div className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity blur-md bg-violet-500/30" />

      {/* Content */}
      <div className="relative flex items-center gap-1.5">
        <motion.div
          animate={{ rotate: [0, 15, -15, 0] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 2 }}
        >
          <Sparkles size={13} className="text-white" />
        </motion.div>
        <span className="text-white text-xs font-medium whitespace-nowrap">
          Explore New Features
        </span>
      </div>

      {/* Pulse ring */}
      <motion.div
        className="absolute inset-0 rounded-full border border-white/20"
        animate={{
          scale: [1, 1.15, 1],
          opacity: [0.5, 0, 0.5],
        }}
        transition={{ duration: 2.5, repeat: Infinity }}
      />
    </motion.button>
  );
};

export default ExploreButton;